__turbopack_context__.v({
  "expertiseBorder": "expertise-module__66zjiG__expertiseBorder",
  "expertiseTitle": "expertise-module__66zjiG__expertiseTitle",
});
